import { IIconProps } from 'src/interfaces/IconProps';

const ResizeTopRightIcon = ({ width = 6, height = 5, color = '#9ea4ac', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M5.26803 4.47482L1.02539 0.232178M4.91447 2.70704L2.79315 0.585728' stroke={color} strokeWidth='0.5' />
  </svg>
);

export default ResizeTopRightIcon;
